import VideoSideModal from "../Modal/VideoSideModal.vue";
export default {
  name: "v-side-modal-news-button",
  data: function data() {
    return {
      isDropdownVisible: false,
      internalVideoUrl: null,
      isVideoSideModal: false
    };
  },
  components: {
    "v-video-side-modal": VideoSideModal
  },
  props: {
    text: String,
    link: String,
    videoUrl: String,
    locale: String
  },
  methods: {
    setVideoUrl: function setVideoUrl(url) {
      var _this = this;
      this.internalVideoUrl = url;
      this.isDropdownVisible = false;
      this.$nextTick(function () {
        _this.openVideoSideModal();
      });
    },
    openVideoSideModal: function openVideoSideModal() {
      this.isVideoSideModal = true;
      if (this.$refs.videoSideModal && typeof this.$refs.videoSideModal.show === 'function') {
        this.$refs.videoSideModal.show();
      } else {
        this.$bvModal.show("video-side-modal");
      }
    },
    toggleDropdown: function toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible;
    },
    onModalHidden: function onModalHidden() {
      this.isVideoSideModal = false;
    }
  }
};